import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CombinedMeasurementsConfig } from "../../@types/Measurements";
import { measurementsService } from "../../services/measurementsService";

/**
 * EN-5134: acknowledges the measurement card set the clinician was just shown.
 *
 * Also clears the flag on the cached Configs entry. The project defaults are
 * `refetchOnMount: false` with a 3 minute `staleTime`, so reopening the patient inside that window
 * serves the cached response — which would still say `measurementCardsChanged: true` and announce a
 * set that has already been acknowledged.
 */
export function useMarkMeasurementCardsSeen() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ patientId, token }: { patientId: number; token: string }) =>
      measurementsService.markMeasurementCardsSeen(patientId, token),
    onSuccess: (_response, { patientId }) => {
      queryClient.setQueryData<CombinedMeasurementsConfig | null>(
        ["combined-measurement-configs", patientId],
        (cached) =>
          cached ? { ...cached, measurementCardsChanged: false } : cached
      );
    },
  });
}
